import axios from 'axios';
import store from '../store'
import router from "../router";

class ClubRepository {

    constructor() {
        this.basePath = store.state.backend;
    }

    allClubs() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs/admin`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    changeProExpirationDate(newProTime) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/clubs/edit-pro`, newProTime, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    createBatch(batch) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/club-batch`, batch, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }
}

export default new ClubRepository();
